// import { Component, Inject } from "@angular/core";
// import { enableProdMode } from "@angular/core";
// import * as jwt_decode from "jwt-decode";
// import { OnInit } from "@angular/core";
// import {
//   Router,
//   RouterStateSnapshot,
//   UrlTree,
//   PRIMARY_OUTLET,
//   ActivatedRoute,
// } from "@angular/router";
// import { NotificationService } from "../services/notification.service";
// import { from } from "rxjs";
// import { NotificationModel } from "../models/notification-model.model";
// import { UserService } from "../services/user.service";
// import { WebStorageService, LOCAL_STORAGE } from "ngx-webstorage-service";
// import { OAuthService } from "angular-oauth2-oidc";
// import { environment } from "../../environments/environment";
// import { core } from "@angular/compiler";
// import { UserRoleUserOperation, UserRole, Constant } from "../core/constant";
// import { CryptographyService } from "../services/cryptography.service";
// import { SuccessDialogComponent } from "../success-dialog/success-dialog.component";
// import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
// import { countryISO } from "../core/constant";
// import { notificationGroup } from "../core/constant";
// import { basicRoleOPerations,marketRoleOPerations,aowRoleOperations } from "../core/constant";
// declare var $: any;
// @Component({
//   selector: "app-home",
//   templateUrl: "./home.component.html",
// })
// export class HomeComponent implements OnInit {
//   private canReceiveMessage: boolean = false;
//   private notificationHistory: NotificationModel[] = [];
//   impersonation: boolean;
//   userRolesId: {} = { basic: 3, marketAdmin: 2 };



//   constructor(
//     private userService: UserService,
//     @Inject(LOCAL_STORAGE)
//     public storage: WebStorageService,
//     private oauthService: OAuthService,
//     private router: Router,
//     private cryptographyService: CryptographyService,
//     private route: ActivatedRoute,
//     private ngbModal: NgbModal
//   ) {}

//   public token: string;
//   userRoleUserOperation: Array<number>;
//   countryIso: string;
//   Name: string;
//   countryId: number;
//   userId: number;
//   userRole: number;
//   notificationGroup: string;
//   returnUrl: string;
//   /**
//    * initialized all data-bound properties.
//    */
//   async ngOnInit() {
//     // alert(":home")
//     const view = sessionStorage.getItem("impersonationView");
//     // console.log("view",view)
//     const reloaded = sessionStorage.getItem("impersonationReloaded");

//     if (view && !reloaded) {
//       sessionStorage.setItem("impersonationReloaded", "true");
//       setTimeout(() => {
//       }, 5000);

//       return;
//     }
//     const dialogShown = sessionStorage.getItem("impersonationDialogShown");
//     const userExit = sessionStorage.getItem("userExit");

//     if (view && !dialogShown) {
//       sessionStorage.setItem("impersonationDialogShown", "true");
//       const modalRef = this.ngbModal.open(SuccessDialogComponent);
//       modalRef.componentInstance.message = "Your Role has been changed.";
//       modalRef.componentInstance.nrbesSuccessPopupEmit.subscribe(() => {
//         this.ngbModal.dismissAll();
//       });
//       modalRef.result
//         .then(() => {
//           this.impersonation = true;
//           window.location.reload();
//         })
//         .catch(() => {
//           window.location.reload();
//           this.impersonation = true;
//         });
//     } else if (userExit) {
//       //  localStorage.setItem("userExit" , "true");
//       const modalRef = this.ngbModal.open(SuccessDialogComponent);
//       modalRef.componentInstance.message =
//         "Your have Exit the Impersonation view";
//       modalRef.componentInstance.nrbesSuccessPopupEmit.subscribe(() => {
//         this.ngbModal.dismissAll();
//         sessionStorage.removeItem("userExit");
//       });
//       modalRef.result
//         .then(() => {
//           this.impersonation = false;
//           window.location.reload();
//         })
//         .catch(() => {
//           window.location.reload();
//           this.impersonation = false;
//         });
//     }
//     if (view && dialogShown) {
//       this.impersonation = true;
//     }

//     void 0;
//     if (environment.skipAuthentication) {
//       // void 0;
//       this.storage.set("userId", this.cryptographyService.encryptData(1));
//       this.storage.set("userRole", this.cryptographyService.encryptData(1));
//       // this.storage.set("token", "dummyToken");

//       // void 0;
//       this.storage.set(
//         "countryId",
//         this.cryptographyService.encryptData([2, 3])
//       );
//       this.storage.set(
//         "uniqueName",
//         this.cryptographyService.encryptData("Developer")
//       );
//       this.storage.set(
//         "email",
//         this.cryptographyService.encryptData("wolf@mcd.com")
//       );
//       let urls = this.router.url;
//       if (
//         !this.cryptographyService.decryptData(
//           this.storage.get("isAuthenticatedUser")
//         )
//       ) {
//         this.setUserDetailByLoggedInUserEmailAndCountryIso(
//           "wolf@mcd.com",
//           "US"
//         );
//       } else {
//         if (
//           this.storage.get("isAuthenticatedUser") &&
//           (this.router.url == "/" || this.router.url == "")
//         ) {
//           this.router.navigateByUrl("/locations");
//         }
//       }
//       //this.storage.set('notificationGroup', this.cryptographyService.encryptData("CANNotificationGroup"));
//       //this.storage.set('notificationGroup', "GlobalNotificationGroup");
//     } else {

//       // console.log("getAccessToken", this.oauthService.getAccessToken());
//       this.token = this.oauthService.getAccessToken();
//       // alert(this.token)
//       // console.log("Token from home", this.token)
//       // this.token = "sample";
//       let tokenInfo = this.getDecodedAccessToken(this.token); // decode token
//       //this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
//       // void 0;
//       let email =
//         tokenInfo.preferred_username || tokenInfo.email || tokenInfo.upn;
//       // void 0;
//       //void 0;
//       // let countryIso = tokenInfo.country;
//       let countryIso = tokenInfo.ctry || "US";

//       // void 0;
//       if (
//         !(this.storage.get("isAuthenticatedUser")
//           ? this.cryptographyService.decryptData(
//               this.storage.get("isAuthenticatedUser")
//             )
//           : this.storage.get("isAuthenticatedUser"))
//       ) {
//         this.storage.set("email", this.cryptographyService.encryptData(email));

//         this.setUserDetailByLoggedInUserEmailAndCountryIso(email, countryIso);
//       } else {
//         if (
//           this.storage.get("isAuthenticatedUser") &&
//           (this.router.url == "/" || this.router.url == "")
//         ) {
//           this.router.navigateByUrl("/locations");
//         } else {
//           // this.router.navigateByUrl(this.router.url);
//         }
//       }

//       this.userService
//         .getUserDetailByLoggedInUserEmailAndCountryIso(email, countryIso)
//         .subscribe(async (data: any) => {
//           if (!data.isValidUser) {
//             return;
//           }
//           // void 0;
//           this.countryId = data.countryId;
//           this.Name = data.name || String(email).toString().split(".", 1)[0];
//           // void 0;
//           this.userRole = data.userRoleId;
//           this.userId = data.id;
//           // console.log("iddd", this.userId)
//           this.notificationGroup = data.notificationGroup;
//           this.countryIso = data.countryIso ? data.countryIso : "";
//           this.userRoleUserOperation = data.userRoleUserOperation;
//           // void 0;
//           if (
//             this.cryptographyService.decryptData(
//               this.storage.get("userRole")
//             ) != data.userRole ||
//             !this.cryptographyService.decryptData(
//               this.storage.get("userRoleUserOperation")
//             ) != data.userRoleUserOperation ||
//             !this.cryptographyService.decryptData(this.storage.get("userId")) !=
//               data.id
//           ) {
//             // void 0;

//             this.storage.set(
//               "countryId",
//               this.cryptographyService.encryptData(this.countryId)
//             );

//             this.storage.set("userName", this.Name);

//             //UserId
//             this.storage.set(
//               "userId",
//               this.cryptographyService.encryptData(this.userId)
//             );

//             //NotificationGroup
//             this.storage.set(
//               "notificationGroup",
//               this.cryptographyService.encryptData(this.notificationGroup)
//             );

//             //User role

//             this.storage.set(
//               "userRole",
//               this.cryptographyService.encryptData(this.userRole)
//             );

//             //isAuthenticatedUser
//             this.storage.set(
//               "isAuthenticatedUser",
//               this.cryptographyService.encryptData(true)
//             );

//             //userRoleUserOperation
//             this.storage.set(
//               "userRoleUserOperation",
//               this.cryptographyService.encryptData(this.userRoleUserOperation)
//             );
//           }
//         });
//     }
//     if (view) {
//       // console.log("after operations",this.cryptographyService.decryptData(this.storage.get("userRoleUserOperation")))
//       const id = this.cryptographyService.decryptData(sessionStorage.getItem("userRoleId"));
//       if(id == 2){
//         this.storage.set(
//         "userRoleUserOperation",
//         this.cryptographyService.encryptData(marketRoleOPerations)
//       );
//       }else if(id == 4){
//         this.storage.set(
//         "userRoleUserOperation",
//         this.cryptographyService.encryptData(aowRoleOperations)
//       );
//       }else{
//         // alert("basic")
//         this.storage.set(
//         "userRoleUserOperation",
//         this.cryptographyService.encryptData(basicRoleOPerations)
//       );
//       // console.log("after basic operations",this.cryptographyService.decryptData(this.storage.get("userRoleUserOperation")))

//       }


//       this.storage.set(
//         "userRole",
//         this.cryptographyService.encryptData(
//           this.cryptographyService.decryptData(
//             sessionStorage.getItem("userRoleId"),
//           ),
//         ),
//       );

//       const selectedCountryRaw = sessionStorage.getItem("selectedCountryID");
//       let impersonationCountryIds: number[] = [];
//       if (selectedCountryRaw) {
//         try {
//           const parsed = JSON.parse(selectedCountryRaw);
//           impersonationCountryIds = Array.isArray(parsed)
//             ? parsed.map((id) => Number(id)).filter((id) => id > 0)
//             : [Number(parsed)].filter((id) => id > 0);
//         } catch {
//           void 0;
//         }
//       }
//       this.storage.set(
//         "countryId",
//         this.cryptographyService.encryptData(impersonationCountryIds),
//       );

//       const notificationCountryKey =
//         impersonationCountryIds.length > 0
//           ? impersonationCountryIds[0]
//           : null;
//       if (notificationCountryKey != null && notificationGroup[notificationCountryKey]) {
//         this.storage.set(
//           "notificationGroup",
//           this.cryptographyService.encryptData(
//             notificationGroup[notificationCountryKey],
//           ),
//         );
//       }
//     }

//     // $(window).scroll(function (event) {
//     //   let st = $(this).scrollTop();
//     //   if (st > 199) {
//     //     $(".filter-panel-row").addClass("freeze");
//     //     $(".filter-panel-row .filter-panel").addClass("collapsed");
//     //   } else {
//     //     $(".filter-panel-row").removeClass("freeze");
//     //     $(".filter-panel-row .filter-panel").removeClass("expanded");
//     //     $(".filter-panel-row .filter-panel").removeClass("collapsed");
//     //   }
//     // });

//     $(document).on("click", ".btn-collapse", () => {
//       $(".filter-panel").removeClass("expanded");
//       $(".filter-panel").addClass("collapsed");
//     });
//     $(document).on("click", ".btn-expand", () => {
//       $(".filter-panel").removeClass("collapsed");
//       $(".filter-panel").addClass("expanded");
//     });
//   }

//   /**
//    * get Decoded Access Token.
//    */
//   getDecodedAccessToken(token: string): any {
//     try {
//       return jwt_decode(token);
//     } catch (Error) {
//       return null;
//     }
//   }

//   /**
//    * set UserDetail By Logged In User Email And Country Iso.
//    */
//   setUserDetailByLoggedInUserEmailAndCountryIso(loggedInUserEmail, countryIso) {
//     this.userService
//       .getUserDetailByLoggedInUserEmailAndCountryIso(
//         loggedInUserEmail,
//         countryIso
//       )
//       .subscribe((data: any) => {
//         // alert("data")
//         // void 0;
//         this.countryId = data.countryId;
//         this.Name =
//           data.name || String(loggedInUserEmail).toString().split(".", 1)[0];
//         this.userRole = data.userRoleId;
//         this.userId = data.id;
//         this.notificationGroup = data.notificationGroup;
//         this.countryIso = data.countryIso ? data.countryIso : "";
//         this.userRoleUserOperation = data.userRoleUserOperation;

//         // void 0;

//         //unauthorized
//         if (!data.isValidUser) {
//           this.router.navigateByUrl("/unauthorized");
//         } else {
//           //CountryId
//           // void 0;

//           this.storage.set(
//             "countryId",
//             this.cryptographyService.encryptData(this.countryId)
//           );

//           this.storage.set("userName", this.Name);

//           //UserId
//           this.storage.set(
//             "userId",
//             this.cryptographyService.encryptData(this.userId)
//           );

//           //NotificationGroup
//           this.storage.set(
//             "notificationGroup",
//             this.cryptographyService.encryptData(this.notificationGroup)
//           );

//           //User role
//           this.storage.set(
//             "userRole",
//             this.cryptographyService.encryptData(this.userRole)
//           );

//           //isAuthenticatedUser
//           this.storage.set(
//             "isAuthenticatedUser",
//             this.cryptographyService.encryptData(true)
//           );

//           //userRoleUserOperation
//           this.storage.set(
//             "userRoleUserOperation",
//             this.cryptographyService.encryptData(this.userRoleUserOperation)
//           );

//           this.storage.set("isImpersonated", true);
//           window.location.reload();

//           // if (
//           //   this.router.url == "/" ||
//           //   this.router.url == "/locations" ||
//           //   this.router.url == ""
//           // ) {
//           //   this.router.navigateByUrl("/locations");
//           //   // window.location.reload();
//           // } else {
//           //   this.router.navigateByUrl(this.router.url);
//           //   // window.location.reload();
//           // }
//           //this.router.navigateByUrl('/locations');
//           //this.router.initialNavigation();
//         }
//       });
//   }
// }


import { Component, Inject } from "@angular/core";
import * as jwt_decode from "jwt-decode";
import { OnInit } from "@angular/core";
import {
  Router,
  ActivatedRoute,
} from "@angular/router";
import { NotificationService } from "../services/notification.service";
import { NotificationModel } from "../models/notification-model.model";
import { UserService } from "../services/user.service";
import { WebStorageService, LOCAL_STORAGE } from "ngx-webstorage-service";
import { OAuthService } from "angular-oauth2-oidc";
import { environment } from "../../environments/environment";
import { CryptographyService } from "../services/cryptography.service";
import { SuccessDialogComponent } from "../success-dialog/success-dialog.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { notificationGroup } from "../core/constant";
import { basicRoleOPerations, marketRoleOPerations, aowRoleOperations } from "../core/constant";

declare var $: any;

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
})
export class HomeComponent implements OnInit {
  private canReceiveMessage: boolean = false;
  private notificationHistory: NotificationModel[] = [];
  impersonation: boolean;
  userRolesId: { basic: 3; marketAdmin: 2 };
  isDataLoading = true;

  constructor(
    private userService: UserService,
    @Inject(LOCAL_STORAGE)
    public storage: WebStorageService,
    private oauthService: OAuthService,
    private router: Router,
    private cryptographyService: CryptographyService,
    private route: ActivatedRoute,
    private ngbModal: NgbModal
  ) {}

  public token: string;
  userRoleUserOperation: Array<number>;
  countryIso: string;
  Name: string;
  countryId: number;
  userId: number;
  userRole: number;
  notificationGroup: string;
  returnUrl: string;

  async ngOnInit() {
    console.log('🏠 HomeComponent initialized');
    
    // ✅ Handle impersonation views
    const view = sessionStorage.getItem("impersonationView");
    const reloaded = sessionStorage.getItem("impersonationReloaded");

    if (view && !reloaded) {
      sessionStorage.setItem("impersonationReloaded", "true");
      setTimeout(() => {}, 5000);
      return;
    }

    const dialogShown = sessionStorage.getItem("impersonationDialogShown");
    const userExit = sessionStorage.getItem("userExit");

    if (view && !dialogShown) {
      sessionStorage.setItem("impersonationDialogShown", "true");
      const modalRef = this.ngbModal.open(SuccessDialogComponent);
      modalRef.componentInstance.message = "Your Role has been changed.";
      modalRef.componentInstance.nrbesSuccessPopupEmit.subscribe(() => {
        this.ngbModal.dismissAll();
      });
      modalRef.result
        .then(() => {
          this.impersonation = true;
          window.location.reload();
        })
        .catch(() => {
          window.location.reload();
          this.impersonation = true;
        });
    } else if (userExit) {
      const modalRef = this.ngbModal.open(SuccessDialogComponent);
      modalRef.componentInstance.message = "Your have Exit the Impersonation view";
      modalRef.componentInstance.nrbesSuccessPopupEmit.subscribe(() => {
        this.ngbModal.dismissAll();
        sessionStorage.removeItem("userExit");
      });
      modalRef.result
        .then(() => {
          this.impersonation = false;
          window.location.reload();
        })
        .catch(() => {
          window.location.reload();
          this.impersonation = false;
        });
    }
    
    if (view && dialogShown) {
      this.impersonation = true;
    }

    // ✅ Skip authentication for development
    if (environment.skipAuthentication) {
      this.storage.set("userId", this.cryptographyService.encryptData(1));
      this.storage.set("userRole", this.cryptographyService.encryptData(1));
      this.storage.set("countryId", this.cryptographyService.encryptData([2, 3]));
      this.storage.set("uniqueName", this.cryptographyService.encryptData("Developer"));
      this.storage.set("email", this.cryptographyService.encryptData("wolf@mcd.com"));
      
      if (!this.cryptographyService.decryptData(this.storage.get("isAuthenticatedUser"))) {
        await this.setUserDetailByLoggedInUserEmailAndCountryIso("wolf@mcd.com", "US");
      }
      this.isDataLoading = false;
      return;
    }

    // ✅ Main authentication flow
    this.token = this.oauthService.getAccessToken();
    let tokenInfo = this.getDecodedAccessToken(this.token);
    let email = tokenInfo.preferred_username || tokenInfo.email || tokenInfo.upn;
    let countryIso = tokenInfo.ctry || "US";

    // ✅ Check if user is already authenticated
    const isAuthenticated = this.storage.get("isAuthenticatedUser")
      ? this.cryptographyService.decryptData(this.storage.get("isAuthenticatedUser"))
      : this.storage.get("isAuthenticatedUser");

    if (!isAuthenticated) {
      console.log('🔄 Fetching user data for first time...');
      this.storage.set("email", this.cryptographyService.encryptData(email));
      await this.setUserDetailByLoggedInUserEmailAndCountryIso(email, countryIso);
      
      // ✅ Reload after first time data fetch (like your original code)
      console.log('🔄 First time data fetched, reloading...');
      window.location.reload();
      return;
    } else {
      console.log('✅ User data already exists in storage');
      
      // ✅ Load data from storage
      this.userId = this.cryptographyService.decryptData(this.storage.get("userId"));
      this.userRole = this.cryptographyService.decryptData(this.storage.get("userRole"));
      this.Name = this.storage.get("userName");
      this.countryId = this.cryptographyService.decryptData(this.storage.get("countryId"));
      this.notificationGroup = this.cryptographyService.decryptData(this.storage.get("notificationGroup"));
      this.userRoleUserOperation = this.cryptographyService.decryptData(this.storage.get("userRoleUserOperation"));
      
      // ✅ Still refresh data in background
      this.refreshUserDataInBackground(email, countryIso);
    }

    // ✅ Handle impersonation view
    if (view) {
      const id = this.cryptographyService.decryptData(sessionStorage.getItem("userRoleId"));
      if (id == 2) {
        this.storage.set(
          "userRoleUserOperation",
          this.cryptographyService.encryptData(marketRoleOPerations)
        );
      } else if (id == 4) {
        this.storage.set(
          "userRoleUserOperation",
          this.cryptographyService.encryptData(aowRoleOperations)
        );
      } else {
        this.storage.set(
          "userRoleUserOperation",
          this.cryptographyService.encryptData(basicRoleOPerations)
        );
      }

      this.storage.set(
        "userRole",
        this.cryptographyService.encryptData(
          this.cryptographyService.decryptData(sessionStorage.getItem("userRoleId"))
        )
      );

      const selectedCountryRaw = sessionStorage.getItem("selectedCountryID");
      let impersonationCountryIds: number[] = [];
      if (selectedCountryRaw) {
        try {
          const parsed = JSON.parse(selectedCountryRaw);
          impersonationCountryIds = Array.isArray(parsed)
            ? parsed.map((id) => Number(id)).filter((id) => id > 0)
            : [Number(parsed)].filter((id) => id > 0);
        } catch {
          // Ignore
        }
      }
      this.storage.set(
        "countryId",
        this.cryptographyService.encryptData(impersonationCountryIds)
      );

      const notificationCountryKey = impersonationCountryIds.length > 0 ? impersonationCountryIds[0] : null;
      if (notificationCountryKey != null && notificationGroup[notificationCountryKey]) {
        this.storage.set(
          "notificationGroup",
          this.cryptographyService.encryptData(notificationGroup[notificationCountryKey])
        );
      }
    }

    this.isDataLoading = false;

    // ✅ jQuery event handlers
    $(document).on("click", ".btn-collapse", () => {
      $(".filter-panel").removeClass("expanded");
      $(".filter-panel").addClass("collapsed");
    });
    $(document).on("click", ".btn-expand", () => {
      $(".filter-panel").removeClass("collapsed");
      $(".filter-panel").addClass("expanded");
    });
  }

  getDecodedAccessToken(token: string): any {
    try {
      return jwt_decode(token);
    } catch (Error) {
      return null;
    }
  }

  /**
   * ✅ Refresh user data in background
   */
  private refreshUserDataInBackground(email: string, countryIso: string) {
    this.userService
      .getUserDetailByLoggedInUserEmailAndCountryIso(email, countryIso)
      .subscribe(
        (data: any) => {
          if (data.isValidUser) {
            console.log('🔄 Background refresh: Updating user data');
            // Update storage with fresh data
            this.storage.set("countryId", this.cryptographyService.encryptData(data.countryId));
            this.storage.set("userName", data.name || this.Name);
            this.storage.set("userId", this.cryptographyService.encryptData(data.id));
            this.storage.set("notificationGroup", this.cryptographyService.encryptData(data.notificationGroup));
            this.storage.set("userRole", this.cryptographyService.encryptData(data.userRoleId));
            this.storage.set("userRoleUserOperation", this.cryptographyService.encryptData(data.userRoleUserOperation));
          }
        },
        (error) => {
          console.error('❌ Background refresh failed:', error);
        }
      );
  }

  /**
   * ✅ Set user data (with reload for first time)
   */
  setUserDetailByLoggedInUserEmailAndCountryIso(loggedInUserEmail, countryIso): Promise<void> {
    return new Promise((resolve, reject) => {
      this.userService
        .getUserDetailByLoggedInUserEmailAndCountryIso(loggedInUserEmail, countryIso)
        .subscribe(
          (data: any) => {
            console.log('📦 User data received:', data);
            
            if (!data.isValidUser) {
              this.router.navigateByUrl("/unauthorized");
              resolve();
              return;
            }

            // ✅ Set all user data
            this.countryId = data.countryId;
            this.Name = data.name || String(loggedInUserEmail).toString().split(".", 1)[0];
            this.userRole = data.userRoleId;
            this.userId = data.id;
            this.notificationGroup = data.notificationGroup;
            this.countryIso = data.countryIso ? data.countryIso : "";
            this.userRoleUserOperation = data.userRoleUserOperation;

            // ✅ Store in storage
            this.storage.set("countryId", this.cryptographyService.encryptData(this.countryId));
            this.storage.set("userName", this.Name);
            this.storage.set("userId", this.cryptographyService.encryptData(this.userId));
            this.storage.set("notificationGroup", this.cryptographyService.encryptData(this.notificationGroup));
            this.storage.set("userRole", this.cryptographyService.encryptData(this.userRole));
            this.storage.set("isAuthenticatedUser", this.cryptographyService.encryptData(true));
            this.storage.set("userRoleUserOperation", this.cryptographyService.encryptData(this.userRoleUserOperation));
            this.storage.set("isImpersonated", true);

            console.log('✅ User data stored successfully');
            console.log('🔵 User role:', this.userRole);
            console.log('🔵 User ID:', this.userId);
            
            resolve();
          },
          (error) => {
            console.error('❌ Error fetching user details:', error);
            reject(error);
          }
        );
    });
  }
}